(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (factory((global.d3 = global.d3 || {})));
}(this, function (exports) { 'use strict';

    //"use strict";

    var _isMethodExact = true;

    function isMethodExact() {
        return _isMethodExact;
    }

    function setMethodExact(on) {
        if (typeof on === "undefined") on = true;
        _isMethodExact = on;
    }

    function setMethodApprox() {
        setMethodExact(false);
    }

    /**
     * @description
     * Build an index to help handle the case of multiple links between two nodes
     * @param links the link array
     * @param LINK_WIDTH default link width in pixels
     */
    function initLinks(links) {
        var LINK_WIDTH = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

        var linksFromNodes = {};
        links.forEach(function (val, idx) {
            var sid = val.source,
                tid = val.target,
                key = sid < tid ? sid + "," + tid : tid + "," + sid;
            if (linksFromNodes[key] === undefined) {
                linksFromNodes[key] = [idx];
                val.multiIdx = 1;
            } else {
                val.multiIdx = linksFromNodes[key].push(idx);
            }
            // Calculate target link distance, from the index in the multiple-links array:
            // 1 -> 0, 2 -> 2, 3-> -2, 4 -> 4, 5 -> -4, ...
            val.targetDistance = val.multiIdx % 2 === 0 ? val.multiIdx * LINK_WIDTH : (-val.multiIdx + 1) * LINK_WIDTH;
        });
    }

    /**
     * @param {number} targetDistance
     * @param {x,y} point0
     * @param {x,y} point1, two points that define a line segmemt
     * @returns
     * a translation {dx,dy} from the given line segment, such that the distance
     * between the given line segment and the translated line segment equals
     * targetDistance
     */
    function calcTranslationExact(targetDistance, point0, point1) {
        var x1_x0 = point1.x - point0.x,
            y1_y0 = point1.y - point0.y,
            x2_x0 = void 0,
            y2_y0 = void 0;
        if (y1_y0 === 0) {
            x2_x0 = 0;
            y2_y0 = targetDistance;
        } else {
            var angle = Math.atan(x1_x0 / y1_y0);
            x2_x0 = -targetDistance * Math.cos(angle);
            y2_y0 = targetDistance * Math.sin(angle);
        }
        return {
            dx: x2_x0,
            dy: y2_y0
        };
    }

    /**
     * @param {number} targetDistance
     * @param {x,y} point0
     * @param {x,y} point1, two points that define a line segmemt
     * @returns
     * a translation {dx,dy} from the given line segment, such that the distance
     * between the given line segment and the translated line segment satisfies
     * the condition: targetDistance < distance < 1.42 * targetDistance
     */
    function calcTranslationApproximate(targetDistance, point0, point1) {
        var x1_x0 = point1.x - point0.x,
            y1_y0 = point1.y - point0.y,
            x2_x0 = void 0,
            y2_y0 = void 0;
        if (targetDistance === 0) {
            x2_x0 = y2_y0 = 0;
        } else if (y1_y0 === 0 || Math.abs(x1_x0 / y1_y0) > 1) {
            y2_y0 = -targetDistance;
            x2_x0 = targetDistance * y1_y0 / x1_x0;
        } else {
            x2_x0 = targetDistance;
            y2_y0 = targetDistance * -x1_x0 / y1_y0;
        }
        return {
            dx: x2_x0,
            dy: y2_y0
        };
    }

    function transform(d) {
        var calcTranslation = isMethodExact() ? calcTranslationExact : calcTranslationApproximate;
        var translation = calcTranslation(d.targetDistance, d.source, d.target);
        return "translate (" + translation.dx + ", " + translation.dy + ")";
    }

    exports.parallelLinksSetMethodExact = setMethodExact;
    exports.parallelLinksSetMethodApprox = setMethodApprox;
    exports.parallelLinksIsMethodExact = isMethodExact;
    exports.parallelLinksInitLinks = initLinks;
    exports.parallelLinksTransform = transform;

    Object.defineProperty(exports, '__esModule', { value: true });

}));


//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-parallel-links/build/d3-parallel-links.js
// module id = 464
// module chunks = 0